import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import durationPlugin, {
  type Duration as DayjsDuration,
} from 'dayjs/plugin/duration';

dayjs.extend(durationPlugin);

enum Unit {
  SECONDE = 's',
  MINUTE = 'm',
  HOUR = 'h',
  DAY = 'd',
}

const ACCEPTED_MIN_UNITS = [Unit.SECONDE, Unit.MINUTE, Unit.HOUR, Unit.DAY];
const DEFAULT_MAX_UNIT = Unit.MINUTE;
const DEFAULT_SEC_BEFORE_HOURS = 7200; // 120 lin

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(durationSec: number, ...options: string[]): string {
    if (isNaN(durationSec)) {
      return null;
    }

    const formatOptionIndex = options.indexOf('format');
    if (options.includes('format')) {
      const format: string = options[formatOptionIndex + 1];
      const dayjsDuration: DayjsDuration = dayjs.duration(
        durationSec,
        'seconds'
      );

      const formatedDate: string = dayjsDuration.format(format);
      if (options[formatOptionIndex + 2] === 'short') {
        return formatedDate.replace(/^00:(?=\d)/, '');
      }

      return formatedDate;
    }

    let maxUnit = DEFAULT_MAX_UNIT;
    const maxUnitIndex = options.indexOf('maxUnit');
    if (maxUnitIndex !== -1) {
      const optionMaxUnit = options[maxUnitIndex + 1];
      if (ACCEPTED_MIN_UNITS.includes(maxUnit)) {
        maxUnit = optionMaxUnit as Unit;
      }
    }
    if (options.includes('value')) {
      return '' + this.getDurationValue(durationSec, maxUnit);
    }
    if (options.includes('unit')) {
      return this.getDurationUnit(durationSec, maxUnit);
    }
  }

  private getDurationValue(durationSec: number, maxUnit: Unit) {
    if (durationSec < 60 || maxUnit === Unit.SECONDE) {
      return Math.floor(durationSec);
    }

    if (durationSec < DEFAULT_SEC_BEFORE_HOURS || maxUnit === Unit.MINUTE) {
      const minutes = Math.floor(durationSec / 60);
      return minutes;
    }

    const hours = Math.floor(durationSec / 3600);
    return hours;
  }

  private getDurationUnit(durationSec: number, maxUnit: Unit): string {
    if (durationSec < 60 || maxUnit === Unit.SECONDE) {
      return 'sec';
    }

    if (durationSec < DEFAULT_SEC_BEFORE_HOURS || maxUnit === Unit.MINUTE) {
      return 'min';
    }

    return 'h';
  }
}
